/* ==========================================================================
   LOVI — LOT 21 (08/08/2026)
   --------------------------------------------------------------------------
   Cible : theme 198820397383 « LOVI V11 », role UNPUBLISHED.
   Charge par snippets/custom-code-body.liquid, en dernier, apres
   lovi-lot20.js. Auto-neutralisant : sort immediatement si la page ne
   contient ni bande de vignettes ni section « geste de 20 secondes ».
   Aucun hook reecrit : ni data-lpdp-pack, ni data-variant-id, ni data-gifts,
   ni data-unlock, ni __loviAtcPrice, ni [data-rc-prev/next/dot].
   ========================================================================== */
(function () {
  'use strict';

  /* ------------------------------------------------------------------
     1. Bande de vignettes — garder la vignette active dans le champ.
     La bande redevient defilante (lot 21, CSS) : sans ce rappel, cliquer
     sur une fleche de la galerie peut activer une vignette situee hors du
     champ visible. On ne touche ni au marquage .is-active, ni au clic :
     on observe, on fait defiler. inline:'nearest' ne bouge la bande que
     si la vignette est reellement hors champ, block:'nearest' empeche
     tout defilement vertical de la page.
     ------------------------------------------------------------------ */
  function bindThumbs() {
    var strip = document.querySelector('.lpdp-gallery__thumbs');
    if (!strip || strip.__lovi21) return;
    strip.__lovi21 = true;

    function reveal() {
      var a = strip.querySelector('.lpdp-gallery__thumb.is-active');
      if (!a) return;
      var sr = strip.getBoundingClientRect();
      var ar = a.getBoundingClientRect();
      if (ar.left < sr.left - 1 || ar.right > sr.right + 1) {
        try {
          a.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
        } catch (e) {
          strip.scrollLeft = a.offsetLeft - (strip.clientWidth - a.offsetWidth) / 2;
        }
      }
    }

    new MutationObserver(reveal).observe(strip, {
      subtree: true, attributes: true, attributeFilter: ['class']
    });
  }

  /* ------------------------------------------------------------------
     2. Section « Un geste de 20 secondes ».
     a) classe de repli .lovi21-steps-sec sur la section, pour les moteurs
        sans :has() — le CSS du lot 21 porte les deux ecritures.
     b) filet de securite sur l'enveloppe .lovi21-quad. Le markup est pose
        par sections/lovi-pdp-steps.liquid ; ce bloc ne sert que si une
        version en cache rend encore l'ancien <img> nu. Idempotent :
        il ne fait rien si l'enveloppe existe deja.
     ------------------------------------------------------------------ */
  function bindSteps() {
    var steps = document.querySelector('.lpdp-steps');
    if (!steps) return;

    var sec = steps.closest('.lpdp-section') || steps.closest('section');
    if (sec) sec.classList.add('lovi21-steps-sec');

    Array.prototype.forEach.call(steps.querySelectorAll('.lpdp-stepcard'), function (card) {
      var img = null, i;
      for (i = 0; i < card.children.length; i++) {
        if (card.children[i].tagName === 'IMG') { img = card.children[i]; break; }
      }
      if (!img) return;                       // deja enveloppe par le Liquid
      var w = document.createElement('span');
      w.className = 'lovi21-quad';
      img.parentNode.insertBefore(w, img);
      w.appendChild(img);
      // la source de repli est rendue a 500 px ; le cadrage affiche l'image
      // a 200 % du conteneur, on demande donc la pleine resolution.
      if (img.src && /[?&]width=\d+/.test(img.src)) {
        img.src = img.src.replace(/([?&]width=)\d+/, '$11254');
      }
    });
  }

  function boot() { bindThumbs(); bindSteps(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
